import React, {Component} from 'react';
import './PortalNav.css';
import PortalNavItem from "./PortalNavItem";
import ContactBlock from "./ContactBlock";
import PropTypes from 'prop-types';
import PortalBranding from "./PortalBranding";

export default class PortalNav extends Component {
    constructor(props) {
        super(props);

        this.state = {
            wasMobileExpanded: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.mobileExpanded) {
            this.setState({
                wasMobileExpanded: true
            });
        }
    }

    render() {
        let classNames = ["PortalNav"];

        if (this.props.mobileExpanded) {
            classNames.push("PortalNav--expanded");
        } else if (this.state.wasMobileExpanded) {
            classNames.push("PortalNav--collapse");
        }

        return (
            <div>
                {this.props.mobileExpanded && <div className={"PortalNav__cover"} onClick={this.props.onMobileClose}/>}
                <div className={classNames.join(' ')}>
                    <div className={"PortalNav__mobile-brand"}>
                        <PortalBranding/>
                    </div>
                    <div className={"PortalNav__links"} onClick={this.props.onMobileClose}>
                        <PortalNavItem label={"Overzicht"} href={"/start"} icon={"home"}
                                       active={this.props.tab === "start"}/>
                        <PortalNavItem label={"Wensenlijst"} href={"/wensen"} icon={"check-decagram"}
                                       active={this.props.tab === "wensen"}/>
                        <PortalNavItem label={"Praktische zaken"} href={"/praktisch"} icon={"gavel"}
                                       active={this.props.tab === "praktisch"}/>
                        <PortalNavItem label={"Genodigdenlijst"} href={"/gasten"} icon={"account"}
                                       active={this.props.tab === "gasten"}/>
                        <PortalNavItem label={"Draaiboek"} href={"/draaiboek"} icon={"calendar-clock"}
                                       active={this.props.tab && this.props.tab.indexOf("draaiboek") === 0}>
                            <PortalNavItem label={"Voor"} href={"/draaiboek/voor"}
                                           active={this.props.tab === "draaiboek_voor"}/>
                            <PortalNavItem label={"Tijdens"} href={"/draaiboek/tijdens"}
                                           active={this.props.tab === "draaiboek_tijdens"}/>
                            <PortalNavItem label={"Na"} href={"/draaiboek/na"}
                                           active={this.props.tab === "draaiboek_na"}/>
                        </PortalNavItem>
                    </div>
                    <ContactBlock/>
                </div>
            </div>
        );
    }
}

PortalNav.propTypes = {
    tab: PropTypes.string,
    mobileExpanded: PropTypes.bool,
    onMobileClose: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/Portal/Parts/PortalNav.js